//旅程一起行
export const evaluateAndInformationRouter = [
  {
    path: '/service/contentInformation/list',
    name: 'ContentList',
    component: () => import('@/views/service/serviceProvider/contentInformation/ContentList'),
    meta: {
      title: '内容资讯',
      keepAlive: false
    }
  },
  {
    path: '/service/contentInformation/classify',
    name: 'ContentCategory',
    component: () => import('@/views/service/serviceProvider/contentInformation/ContentCategory'),
    meta: {
      title: '内容分类',
      keepAlive: false
    }
  },
  {
    path: '/service/contentInformation/introduction',
    name: 'Introduction',
    component: () => import('@/views/service/serviceProvider/contentInformation/Introduction'),
    meta: {
      title: '景区介绍',
      keepAlive: false
    }
  },
  {
    path: '/service/contentInformation/dynamic',
    name: 'ScenicAreaDynamic',
    component: () => import('@/views/service/serviceProvider/contentInformation/ScenicAreaDynamic'),
    meta: {
      title: '景区动态',
      keepAlive: false
    }
  },
  {
    path: '/service/contentInformation/addContentList',
    name: 'AddContentList',
    component: () => import('@/views/service/serviceProvider/contentInformation/AddContent'),
    meta: {
      title: '新建内容',
      keepAlive: false
    }
  },
  {
    path: '/service/contentInformation/addDynamic',
    name: 'AddDynamic',
    component: () => import('@/views/service/serviceProvider/contentInformation/AddDynamic'),
    meta: {
      title: '新建动态',
      keepAlive: false
    }
  },
  {
    path: '/service/creditEvaluation/list',
    name: 'ShopEvaluateList',
    component: () => import('@/views/service/serviceProvider/creditEvaluation/ShopList'),
    meta: {
      title: '诚信评价',
      keepAlive: false
    }
  },
  {
    path: '/service/creditEvaluation/evaluationList',
    name: 'EvaluationList',
    component: () => import('@/views/service/serviceProvider/creditEvaluation/EvaluationList'),
    meta: {
      title: '评价列表',
      keepAlive: false
    }
  },
  {
    path: '/service/suggestionFeedback/feedbackList',
    name: 'FeedbackList',
    component: () => import('@/views/service/serviceProvider/suggestionFeedback/FeedbackList'),
    meta: {
      title: '反馈列表',
      keepAlive: false
    }
  }
]